<template>
  <div>
    <a
      v-if="data.previewUrl !== null"
      :href="data.previewUrl"
      :disabled="data.enabled"
      target="_blank"
    >
      Preview
    </a>
  </div>
</template>

<script>

export default {
  data () {
    return {
      data: {}
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
